const { Record } = require('immutable')

export default Record({
    error: null,
    isFetching: false,
    shouldReload: false,
    dataSource: Record({
        data: Record({
            contacts: [],
            attorneys: []
        })(),
        pagination: Record({
            sort: '',
            page: 1,
            size: 15,
            totalCount: 0
        })()
    })()
})